import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReviewEditStep = ({ 
  generatedContent, 
  onContentChange,
  onRegenerate,
  isRegenerating 
}) => {
  const [editMode, setEditMode] = useState(false);

  const handleContentChange = (e) => {
    onContentChange(e?.target?.value);
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-white mb-2">Vérification du compte rendu</h2>
        <p className="text-gray-400">Relisez et corrigez le compte rendu généré par l'IA</p>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => setEditMode(!editMode)}
            className={`
              px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2
              ${editMode
                ? 'bg-blue-500 text-white' :'bg-gray-800/50 text-gray-300 hover:bg-gray-700/50'
              }
            `}
          >
            <Icon name={editMode ? 'Eye' : 'Edit'} size={16} />
            {editMode ? 'Mode lecture' : 'Mode édition'}
          </button>
        </div>

        <Button
          variant="outline"
          onClick={onRegenerate}
          loading={isRegenerating}
          iconName="RefreshCw"
          iconPosition="left"
          className="border-blue-500/30 text-blue-400 hover:bg-blue-500/10"
        >
          Regénérer
        </Button>
      </div>

      {/* Content Display/Edit */}
      <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
        {editMode ? (
          <textarea
            value={generatedContent}
            onChange={handleContentChange}
            rows={20}
            className="w-full px-4 py-3 bg-gray-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50 resize-none font-mono text-sm"
          />
        ) : (
          <div className="prose prose-invert max-w-none">
            <div className="whitespace-pre-wrap text-gray-200 leading-relaxed">
              {generatedContent}
            </div>
          </div>
        )}
      </div>

      {/* Info Box */}
      <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-6">
        <h4 className="text-white font-semibold mb-3 flex items-center gap-2">
          <Icon name="Info" size={18} className="text-blue-400" />
          Conseils de vérification
        </h4>
        <ul className="space-y-2 text-sm text-gray-300">
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-green-400 mt-0.5" />
            <span>Vérifiez que toutes les informations cliniques sont exactes</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-green-400 mt-0.5" />
            <span>Corrigez les éventuelles erreurs ou imprécisions</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Check" size={16} className="text-green-400 mt-0.5" />
            <span>À l'étape suivante, vous pourrez demander des ajustements spécifiques</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ReviewEditStep;